// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1Aqim","errors":"Errors_errors__23yYg"};